// Hreflang alternates per page (FR ↔ EN). Use on any page that has a translated EN equivalent.
// Provide the FR canonical path; we derive the EN one from ROUTE_MAP.

import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/seo-jsonld";
import { ROUTE_MAP } from "@/i18n/routes";

interface Props {
  /** Canonical FR path, e.g. "/faq" */
  frPath: string;
  /** Optional explicit EN path, otherwise derived from ROUTE_MAP or "/en{frPath}" */
  enPath?: string;
}

const HreflangFrEn = ({ frPath, enPath }: Props) => {
  const en = enPath ?? ROUTE_MAP[frPath] ?? `/en${frPath === "/" ? "" : frPath}`;
  return (
    <Helmet>
      <link rel="alternate" hrefLang="fr-FR" href={`${SITE_URL}${frPath}`} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}${en}`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${frPath}`} />
    </Helmet>
  );
};

export default HreflangFrEn;
